export const tagLocale = {
    removeLabel: 'Remove',
};
//# sourceMappingURL=Tag.locale.js.map